import { render } from "./DistributionModal.vue?vue&type=template&id=5b7c937d"
import script from "./DistributionModal.vue?vue&type=script&lang=js"
export * from "./DistributionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__